// assets
import { DashboardOutlined, PullRequestOutlined, AccountBookOutlined } from '@ant-design/icons';

// icons
const icons = {
    DashboardOutlined,
    PullRequestOutlined,
    AccountBookOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
    id: 'group-dashboard',
    title: 'Navigation',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Order',
            type: 'item',
            url: '/',
            icon: icons.DashboardOutlined,
            breadcrumbs: false
        },
        {
            id: 'reservation',
            title: 'Reservation',
            type: 'item',
            url: '/reservation',
            icon: icons.AccountBookOutlined,
            breadcrumbs: false
        },
        {
            id: 'paymentRequest',
            title: 'Payment Request',
            type: 'item',
            url: '/paymentRequest',
            icon: icons.PullRequestOutlined,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
